import { IconKeyboardArrowDown } from "../icon/variants/IconKeyboardArrowDown.js";
import { BaseCard } from "../card/BaseCard.js";
import { HorizontalDivider } from "../divider/variants/HorizontalDivider.js";
import { Subtitle2 } from "../typography/Subtitle2.js";
import accordion_module_default from "./accordion.module.js";
import { Accordion } from "@mantine/core";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/accordion/Accordion.tsx
const Accordion$1 = ({ border = false, defaultValue, divider = true, items, multiple = false, "data-testid": testId }) => {
	const cards = items.flatMap(({ header, key, Icon, ...restProps }, idx, arr) => {
		const card = /* @__PURE__ */ jsxs(Accordion.Item, {
			value: key,
			children: [/* @__PURE__ */ jsx(Accordion.Control, {
				icon: Icon ? /* @__PURE__ */ jsx(Icon, {}) : null,
				children: /* @__PURE__ */ jsx(Subtitle2, { children: header })
			}), /* @__PURE__ */ jsx(Accordion.Panel, { children: /* @__PURE__ */ jsx(BaseCard, {
				...restProps,
				radius: 0,
				padding: 0
			}) })]
		}, key);
		if (divider && arr.length - 1 !== idx) return [card, /* @__PURE__ */ jsx(HorizontalDivider, {}, `${key}-divider`)];
		return card;
	});
	return /* @__PURE__ */ jsx(Accordion, {
		multiple,
		defaultValue,
		classNames: accordion_module_default,
		chevron: /* @__PURE__ */ jsx(IconKeyboardArrowDown, { color: "gray" }),
		"data-testid": testId,
		style: {
			border: border ? "1px solid var(--mantine-color-default-border)" : 0,
			borderRadius: "var(--accordion-radius)"
		},
		children: cards
	});
};

//#endregion
export { Accordion$1 as Accordion };